<template>
  <div>
    <div class="page-header">
      <h3>Completed Tasks by {{ $t("tags.singular") }}</h3>
    </div>

    <CompletedTasksFilter />

    <span v-for="tag in allTags" v-if="tagTasks(tag).length">
      <h4  class="mt-4">{{tag.name}}</h4>
      <ul class="mt-2 list-group">
        <li v-for="task in tagTasks(tag)" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
          <QuickTask :task="task"/>
        </li>
      </ul>
    </span>
  </div>
</template>

<script>
import api from "api";
import QuickTask from "components/QuickTask";
import CompletedTasksFilter from "components/CompletedTasksFilter";

export default {
  components: {
    QuickTask,
    CompletedTasksFilter
  },
  computed: {
    allTags: {
      get() {
          return this.$store.state.active_tags
      }
    }
  },
  methods: {
    tagTasks: function(tag){
      return this.$store.state.tasks.filter(function (task){
        return (task.formatted_tag_list.includes(tag.name) && (task.completed === true && task.journaled === false))
      })
      .sort(function(a, b) {
        return new Date(b.completed_at) - new Date(a.completed_at);
      });
    }
  }
};
</script>
